import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Icon, message, Modal, Input, Select, Button } from "antd";
import omit from "lodash.omit";
import { receiveError } from "../../../api/http";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
/* import Button from "../../../components/Shared/Button"; */
import BackLink from "../../../components/Shared/BackLink";
import BorderlessInput from "../../../components/Shared/BorderlessInput";
import { fetchRoles } from "../../../actions/roles";
import { refresh_profile } from "../../../actions/auth";

import "./index.scss";

class InviteUser extends React.Component {
  constructor(props) {
    super();
    const { user } = props;

    this.initialForm = {
      row_1: {
        first_name: "",
        last_name: "",
        email: "",
        role_id: undefined
      },
      row_2: {
        first_name: "",
        last_name: "",
        email: "",
        role_id: undefined
      },
      row_3: {
        first_name: "",
        last_name: "",
        email: "",
        role_id: undefined
      }
    };

    this.state = {
      hasNoCards: false,
      loading: false,
      rowCount: 3,
      counter: 3,
      form: this.initialForm,
      roles: [],
      modalVisible: false
    };

    this.roles = [];
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addInputRow = this.addInputRow.bind(this);
    this.deleteInputRow = this.deleteInputRow.bind(this);
    this.handleGoToBilling = this.handleGoToBilling.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    this.props.fetchRoles();
    this.props.refresh_profile(true);

    CloudFlyerAPI.billing.fetchPaymentProfiles().then(({ data }) => {
      const hasNoCards = data["billing_payment_profiles"].length === 0;
      this.setState({ hasNoCards });
    });
  }

  componentWillReceiveProps({ roles, user }) {
    if (roles.error) {
      message.error(roles.error);
    } else if (roles.items !== null) {
      this.setState({
        roles: roles.items.filter(r => r.title !== "Owner"),
        user
      });
    }
  }

  isUserValid(user) {
    return user.first_name && user.last_name && user.email && user.role_id;
  }

  handleChange({ target }) {
    const { form } = this.state;
    const { name, value } = target;
    const [rowName, fieldName] = name.split(".");
    this.setState({
      form: {
        ...form,
        [rowName]: {
          ...form[rowName],
          [fieldName]: value
        }
      }
    });
  }

  handleSelect(row, newRole) {
    const { form } = this.state;
    this.setState({
      form: {
        ...form,
        [row]: {
          ...form[row],
          role_id: newRole
        }
      }
    });
  }

  addInputRow() {
    const { form, rowCount, counter } = this.state;
    const newRowCount = rowCount + 1;
    const newCounter = counter + 1;
    this.setState({
      rowCount: newRowCount,
      counter: newCounter,
      form: {
        ...form,
        [`row_` + newCounter]: {
          first_name: "",
          last_name: "",
          email: "",
          role_id: undefined
        }
      }
    });
  }

  deleteInputRow(index) {
    const { form, rowCount } = this.state;
    if (rowCount === 1) {
      return;
    }
    const newRowCount = rowCount - 1;
    this.setState({
      rowCount: newRowCount,
      form: omit(form, [`row_` + index])
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { form, hasNoCards, user: { has_billing_info } = {} } = this.state;
    const { history } = this.props;

    if (hasNoCards) {
      history.push("/billing");
      message.info("You need to add a credit card in order to add users.");
    } else {
      if (!has_billing_info) {
        this.setState({ modalVisible: true });
        return;
      }

      const users = Object.keys(form)
        .map(key => form[key])
        .filter(user => this.isUserValid(user));

      for (let key in users) {
        users[key].email = users[key].email.toLowerCase();
      }

      if (users.length > 0) {
        CloudFlyerAPI.user_account
          .invite(users)
          .then(() => {
            message.success(users.length + " invites successfully sent.");
            this.setState({ form: this.initialForm });
          })
          .catch(this.handleError);
      }
    }
  }

  handleError(err) {
    const { message } = receiveError(null, err);
    message.error(message);
  }

  handleGoToBilling(e) {
    const { history } = this.props;
    this.setState({ modalVisible: false });
    history.push("/billing");
  }

  handleModalClose(e) {
    this.setState({ modalVisible: false });
  }

  render() {
    const { form, rowCount, roles, hasNoCards } = this.state;
    const inputRows = Object.keys(form).map(key => {
      const index = key.split("_")[1];
      return (
        <div key={index} className="input-row">
          <Input
            value={form[`row_${index}`].first_name}
            name={`row_${index}.first_name`}
            placeholder="First Name"
            required
            onChange={this.handleChange}
            className="row-input"
          />

          <Input
            value={form[`row_${index}`].last_name}
            name={`row_${index}.last_name`}
            placeholder="Last Name"
            required
            onChange={this.handleChange}
            className="row-input"
          />

          <Input
            value={form[`row_${index}`].email}
            name={`row_${index}.email`}
            placeholder="Email"
            required
            type="email"
            onChange={this.handleChange}
            className="row-input"
          />

          <Select
            onChange={roleId => this.handleSelect(`row_${index}`, roleId)}
            className="row-input select-role"
            placeholder="Role"
            value={form[`row_${index}`].role_id}
          >
            {roles.map((role, i) => (
              <Select.Option value={role.id} key={i}>
                {role.title}
              </Select.Option>
            ))}
          </Select>
          <Button
            className="delete-btn"
            icon="delete"
            onClick={this.deleteInputRow.bind(null, index)}
          />
        </div>
      );
    });
    return (
      <div className="invite-user-container">
        <Modal
          cancelButtonProps={{ style: { display: "none" } }}
          okText="Go to Billing"
          visible={this.state.modalVisible}
          closable={true}
          onCancel={this.handleModalClose}
          onOk={this.handleGoToBilling}
        >
          <div>
            <h3>Adding New Users:</h3>
            <p>
              In order to invite a new user, you must enter your billing
              information. Each new user will be $8/month.
            </p>
          </div>
        </Modal>
        <h3>Invite New Users</h3>
        <div className="invite-user">
          <form method="post">
            {inputRows}
            <div className="actions">
              <a onClick={this.addInputRow}>
                <Icon type="plus-circle" />
                &nbsp; Add More Invites
              </a>
              <Button type="primary" icon="mail" onClick={this.handleSubmit}>
                Send Invites
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ roles, auth: { user } = {} }) {
  return { roles, user };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchRoles: bindActionCreators(fetchRoles, dispatch),
    refresh_profile
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(InviteUser)
);
